import templateUrl from "emun.order/inactive-orders/inactive-orders-list-grid.htm";

export default () => ({ templateUrl });